class AccountMerge {
    constructor(params) {
        this._name = (params.NAME || '').trim();
        this._lastName = (params.LAST_NAME || '').trim();
        this._userName = '';
        if (this._name) {
            this._userName += this._name;
        }
        if (this._lastName) {
            this._userName += ((this._userName) ? ' ' : '') + this._lastName;
        }
        this._title = params.TITLE;
        this._userId = params.USER_ID;
        this._lastActivity = params.LAST_ACTIVITY;
        this._type = params.TYPE;
        
        this._iconClass = '';
        if (this._type) {
            this._iconClass = ' user-account__icon_' + this._type.toLowerCase();
        }
        
        this._socialServiceAuth = params.SOCIAL_SERVICE_OAUTH;
        
        this._textSuccess = 'Ваши аккаунты успешно были объединены';
        this._textError = 'Объединение не удалось';
    
        this._remove = this._remove.bind(this);
        this._reject = this._reject.bind(this);
        this._confirm = this._confirm.bind(this);
        this._submitCode = this._submitCode.bind(this);
        
        this._create();
        this._action = this.el.querySelector('.js-account-merge__action');
        this._btnConfirm = this.el.querySelector('.js-account-merge__confirm');
        this._btnReject = this.el.querySelector('.js-account-merge__reject');
    }
    
    _create() {
        const node = document.createElement('div');
        node.classList.add('accounts-merge-item', 'js-account-merge');
        node.innerHTML = this._getHTML();
        this.el = node;
    }
    
    _getHTML() {
        return `<div class="accounts-merge-item__inner">
                    <div class="accounts-merge-item__info">
                        <div class="accounts-merge-item__user user-account">
                            <div class="user-account__icon${this._iconClass}"></div>
                            <div class="user-account__info">
                                <span class="user-account__title">${(this._userName) ? this._userName : this._title}</span>
                                ${(this._userName && this._title) ? `<span class="user-account__sub">${this._title}</span>` : ''}
                            </div>
                        </div>` +
                        ((this._lastActivity) ? `<span class="accounts-merge-item__date"><span>Последняя активность:</span> <span>${this._lastActivity}</span></span>` : '') +
                    `</div>
                    <div class="accounts-merge-item__action js-account-merge__action">
                        <div class="accounts-merge-item__buttons">
                            <button class="ui-btn ui-btn_red accounts-merge-item__button js-account-merge__confirm"><span class="ui-btn__title">Да, это мой аккаунт</span></button>
                            <button class="ui-btn ui-btn_white-red accounts-merge-item__button js-account-merge__reject"><span class="ui-btn__title">Нет, это не я</span></button>
                        </div>
                    </div>
                </div>`;
    }
    
    _createCodeBlock() {
        const node = document.createElement('div');
        node.classList.add('code-submitter', 'accounts-merge-item__submit');
        node.innerHTML = this._getCodeBlockHTML();
    
        this._inputCode = node.querySelector('.js-account-merge__submitter-input');
        this._inputWrap = node.querySelector('.ui-input-custom');
        this._buttonCode = node.querySelector('.js-account-merge__submitter-button');
        this._buttonCode.addEventListener('click', this._submitCode);
    
        const $input = $(this._inputCode);
        $input.inputmask({
            mask: '9999',
            placeholder: 'XXXX',
            clearMaskOnLostFocus: true,
            showMaskOnFocus: true,
            showMaskOnHover: false
        })
        $input.on('input', event => {
            if (!$(this._inputCode).inputmask('isComplete')) {
                this._buttonCode.setAttribute('disabled', true);
            } else {
                this._buttonCode.removeAttribute('disabled');
            }
        })
        this._inputCode.addEventListener('keyup', (event) => {
            if (event.key === 'Enter' || event.keyCode === 13) {
                this._submitCode();
            }
        })
    
        this._codeText = node.querySelector('.js-account-merge__code-text');
        this._codeBlock = node;
        
        this._setTimer();
        
        this._action.innerHTML = '';
        this._action.appendChild(node);
    }
    
    _setTimer() {
        let seconds = 60;
        this._codeText.innerHTML = `Новый код можно получить через <span class="js-account-merge__submitter-timer">${this._formatSecondsToTime(seconds)}</span>`;
        const timer = this._codeText.querySelector('.js-account-merge__submitter-timer');
        let timerInterval = setInterval(() => {
            if (--seconds > 0) {
                timer.innerText = this._formatSecondsToTime(seconds);
            } else {
                clearInterval(timerInterval);
                const resend = document.createElement('a');
                resend.href = 'javascript:;';
                resend.classList.add('link-txt', '_red');
                resend.innerText = 'Отправить новый код';
                resend.addEventListener('click', this._confirm);
                this._codeText.innerHTML = '';
                this._codeText.appendChild(resend);
                // $resend.html ('<a href="#" class="link-txt _red js-form-auth-code__resend">Отправить новый код</a>')
            }
        }, 1000)
    }
    
    _getCodeBlockHTML() {
        let text = '';
        switch (this._type) {
            case 'EMAIL':
                text = `Введите код, отправленный на&nbsp;эл.&nbsp;адрес ${this._title}.`;
                break;
            case 'PHONE':
                text = `Введите код из&nbsp;SMS сообщения, отправленного на&nbsp;номер ${this._title}.`;
                break;
        }
        return `<p class="code-submitter__text">${text}</p>
                <div class="code-submitter__submitter">
                    <div class="code-submitter__input">
                        <div class="ui-input-custom">
                            <div class="ui-input-custom__box">
                                <input class="ui-input-custom__input js-account-merge__submitter-input" type="text" value="" placeholder="XXXX">
                            </div>
                        </div>
                    </div>
                    <div class="code-submitter__button">
                        <button class="ui-btn ui-btn_red js-account-merge__submitter-button" disabled><span class="ui-btn__title">Подтвердить</span></button>
                    </div>
                </div>
                <p class="code-submitter__code-text js-account-merge__code-text"></p>`;
    }
    
    _enableSubmitter() {
        this._buttonCode.removeAttribute('disabled');
        $(this._inputWrap).trigger('inputDoAble');
    }
    
    _disableSubmitter() {
        this._buttonCode.setAttribute('disabled', true);
        $(this._inputWrap).trigger('inputDoDisable');
    }
    
    _formatSecondsToTime(seconds) {
        const date = new Date(0);
        date.setSeconds(seconds);
        if (seconds > 3599) {
            return date.toISOString ().substr (11, 8);
        } else {
            return date.toISOString ().substr (14, 5);
        }
    }
    
    _showLoadingBlock(text = 'Ожидание') {
        this._action.innerHTML = `
            <div class="accounts-merge-item__loading">
                <span class="ui-loader accounts-merge-item__loading-loader"><span class="ui-loader__left"></span><span class="ui-loader__right"></span></span>
                <span class="accounts-merge-item__loading-text">${text}</span>
            </div>`;
    }
    
    _remove() {
        const height = this.el.scrollHeight;
        this.el.style.height = height + "px";
        window.setTimeout(() => {
            this.el.style.height = "0px";
        }, 10);
        this.el.addEventListener('transitionend', () => {
            this.el.remove();
        });
    }
    
    _confirm(event) {
        event.preventDefault();
        
        if (this._socialServiceAuth) {
            // подтверждение через сервисы
    
            this._showLoadingBlock('Ожидается подтверждение аккаунта');
            
            const a = document.createElement('a');
            a.href = this._socialServiceAuth;
            a.target = '_blank';
    
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true
            });
            a.dispatchEvent(clickEvent);
            
            let checkCounter = 0;
            let checkInterval = setInterval(() => {
                checkCounter++;
                if (checkCounter > 60) {
                    clearInterval(checkInterval);
                    this._error('Время ожидания проверки истекло');
                    return false;
                } else {
                    BX.ajax.runAction('alpina:mergeaccounts.api.user.checkConfirmCode', {
                        data: {
                            toUserId: this._userId,
                            code: 999999
                        }
                    }).then(response => {
                        clearInterval(checkInterval);
                        this._success(this._textSuccess);
                    }, response => {
                        if ('errors' in response && response.errors.length > 0) {
                            let isMergeFailed = false;
                            response.errors.forEach(function(error) {
                                if ('code' in error && error.code === 'MERGE FAILED') {
                                    isMergeFailed = true;
                                }
                            })
                            if (isMergeFailed) {
                                clearInterval(checkInterval);
                                this._error(this._textError);
                            }
                        }
                    })
                }
            }, 5000);
            
        } else {
            // подтверждение через отправку кода
            
            BX.ajax.runAction('alpina:mergeaccounts.api.user.sendConfirmCode', {
                data: {
                    toUserId: this._userId
                }
            }).then((response) => {
                this._createCodeBlock();
            }, (response) => {
                if ('errors' in response && response.errors.length > 0) {
                    let isCodeSent = false;
                    response.errors.forEach(function(error) {
                        if ('message' in error && error.message === 'Код подтверждения уже был отправлен ранее') {
                            isCodeSent = true;
                        }
                    })
                    if (isCodeSent) {
                        // если код уже отправлен, показываем поле для ввода кода
                        this._createCodeBlock();
                    } else {
                        // другая ошибка вызывает показ дефолтного текста
                        this._error(this._textError);
                    }
                }
            });
        }
    }
    
    _reject(event) {
        event.preventDefault();
        BX.ajax.runAction('alpina:mergeaccounts.api.user.disableAccount', {
            data: {
                candidateUserId: this._userId
            }
        }).then((response) => {
            this.el.setAttribute('data-status', 'reject');
            const event = new CustomEvent('accountMerge.reject');
            this.el.dispatchEvent(event);
            
            this._action.innerHTML = '';
            const alert = new Alert({'text': 'Мы больше не будем напоминать вам об этом аккаунте'});
            const alertNode = alert.getNode();
    
            this._action.appendChild(alertNode);
            window.setTimeout(() => {
                this._remove();
            }, 2000);
            
        }, (response) => {
            // ошибка при отказе
            this._error('Не удалось отказаться от аккаунта');
        });
    }
    
    _submitCode(event) {
        if ($(this._inputCode).inputmask('isComplete')) {
            const value = $(this._inputCode).inputmask('unmaskedvalue');
    
            this._disableSubmitter();
    
            BX.ajax.runAction('alpina:mergeaccounts.api.user.checkConfirmCode', {
                data: {
                    toUserId: this._userId,
                    code: value
                }
            }).then(response => {
                this._success(this._textSuccess);
                
            }, response => {
                this._enableSubmitter();
                
                if ('errors' in response && response.errors.length > 0) {
                    let isWrongCode = false;
                    response.errors.forEach(function(error) {
                        if ('message' in error && error.message === 'Код не верный') {
                            isWrongCode = true;
                        }
                    })
                    if (isWrongCode) {
                        // код неверный
                        const $input = $(this._inputCode);
                        $input.trigger('inputError', {text: 'Код неверный'});
                        $input.one('input', event => {
                            $input.trigger('inputResolveErrors');
                        })
                    } else {
                        // другая ошибка вызывает показ дефолтного текста
                        this._error(this._textError);
                    }
                }
            })
        } else {
            this._inputCode.focus();
        }
    }
    
    _success(text = 'Успешно') {
        this.el.setAttribute('data-status', 'success');
        this._action.innerHTML = `<div class="ui-alert ui-alert_success">${text}</div>`;
    
        const event = new CustomEvent('accountMerge.success');
        this.el.dispatchEvent(event);
    }
    
    _error(text = 'Произошла ошибка') {
        this.el.setAttribute('data-status', 'error');
        this._action.innerHTML = `<div class="ui-alert ui-alert_danger">${text}</div>`;

        const event = new CustomEvent('accountMerge.error');
        this.el.dispatchEvent(event);
    }
    
    init() {
        this._btnReject.addEventListener('click', this._reject);
        this._btnConfirm.addEventListener('click', this._confirm);
    }
}

(function () {
    $ (function () {
        const countItems = function($wrap) {
            const $mergeItems = $wrap.find('.js-account-merge');
            const items = {
                left: 0,
                success: 0,
                error: 0
            };
            let itemsLen = $mergeItems.length;
            $mergeItems.each((index, item) => {
                const status = item.getAttribute('data-status');
                if (status === 'success') {
                    itemsLen--;
                    items.success++;
                } else if (status === 'error') {
                    itemsLen--;
                    items.error++;
                } else if (status === 'reject') {
                    itemsLen--;
                }
            })
            
            items.left = itemsLen;
            return items;
        }
        const showModal = function() {
            $('#modalAccountsMerge').iModalOpen({
                afterLoad: function(instance, current) {
                    const $slide = current.$slide;
                    const $wrap = $slide.find('.js-merge-accounts');
                    const checkModal = function() {
                        const items = countItems($wrap);
                        if (items.left === 0) {
                            instance.close();
                        }
                    }
                    if ($wrap.length > 0 && 'usersMerge' in window && window.usersMerge.length > 0) {
                        window.usersMerge.forEach(function(item) {
                            const itemInstance = new AccountMerge(item);
                            itemInstance.init();
                            
                            $wrap.append(itemInstance.el);
                            
                            // ошибка объединения
                            itemInstance.el.addEventListener('accountMerge.error', event => {
                                checkModal();
                            });
                            // успешное объединение
                            itemInstance.el.addEventListener('accountMerge.success', event => {
                                checkModal();
                            });
                            // отказ от объединения
                            itemInstance.el.addEventListener('accountMerge.reject', event => {
                                checkModal();
                            });
                        })
                    }
                },
                
                beforeClose: function(instance, current, e) {
                    const $slide = current.$slide;
                    const $wrap = $slide.find('.js-merge-accounts');
                    const items = countItems($wrap);
                    
                    let resultText;
                    let statusClass;
                    
                    if (items.success > 0) {
                        // есть успешные
                        statusClass = 'ui-status_success';
                        if (items.left > 0 || items.error > 0) {
                            // но есть без реакции или с ошибками
                            resultText = 'Выбранные аккаунты были успешно объединены.<br>Оставшиеся аккаунты вы&nbsp;можете объединить позднее в&nbsp;личном кабинете.';
                        } else {
                            // только успешные
                            resultText = 'Аккаунты были успешно объединены';
                        }
                    } else if (items.left > 0) {
                        // нет успешных, остались без реакции
                        statusClass = 'ui-status_success';
                        resultText = 'Оставшиеся аккаунты вы&nbsp;можете объединить позднее в&nbsp;личном кабинете.';
                    } else if (items.error > 0) {
                        // только ошибки, ничего больше
                        statusClass = 'ui-status_fail';
                        resultText = 'Аккаунты не&nbsp;удалось объединить.<br>Вы&nbsp;можете попробовать позднее в&nbsp;личном кабинете.';
                    } else {
                        // все отменены без ошибок и успешных
                        statusClass = 'ui-status_success';
                        resultText = 'Аккаунты не&nbsp;были объединены';
                    }
                    
                    // по этой куке отменяется показ, даже если передан параметр
                    $.cookie('noRemindAboutMerge', '1', {expires: 180, path: '/'});
                    
                    window.accountsMergeText = resultText;
                    window.accountsMergeClass = statusClass;
                },
                
                afterClose: function() {
                    if ('accountsMergeText' in window && window.accountsMergeText
                        && 'accountsMergeClass' in window && window.accountsMergeClass) {
                        
                        $('#modalAccountsMergeResult').iModalOpen({
                            afterLoad: function(instance, current) {
                                const $slide = current.$slide;
                                $slide.find('.js-merge-result-text').html(window.accountsMergeText);
                                $slide.find('.js-merge-result-status').addClass(window.accountsMergeClass);
                            },
                            beforeClose: function(instance, current, e) {
                                window.location.reload();
                            }
                        })
                    }
                    
                }
            });
        }
        const getMergeAccounts = function() {
            BX.ready(function() {
                BX.ajax.runAction('alpina:mergeaccounts.api.user.getAccountsList')
                    .then(
                        function (response) {
                            if ('data' in response && response.data.length > 0) {
                                window.usersMerge = response.data;
                                showModal();
                            }
                        }, function (response) {
                            console.log(response);
                        }
                    );
            });
        }
        
        // автопоказ модалки
        setTimeout(() => {
            const instance = $.fancybox.getInstance();
            if ('needMergeAccounts' in window && window.needMergeAccounts && $.cookie('noRemindAboutMerge') !== '1' && !(instance && instance.isVisible)) {
                getMergeAccounts();
            }
        }, 500);
        
        // показ модалки по клику
        document.addEventListener('click', function(event) {
            if (event.target.classList.contains('js-merge-accounts-open')) {
                getMergeAccounts();
            }
        })
    });
} ());
